// extracted by mini-css-extract-plugin
export default {"KnowledgeBase":"KnowledgeBase_KnowledgeBase__GU70u"};